<template>
    <div class="profile-card-button">
        <el-button
            type="primary"
            @click="openLink"
        >
            <span class="standard">
                {{ $trans('web_search.profile_card.open_manager_profile') }}
            </span>
        </el-button>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    methods: {
        openLink() {
            window.open(this.url, "_blank");
        },
    },
};
</script>

<style scoped>
.el-button--primary {
    --el-button-text-color: var(--el-color-white);
    --el-button-bg-color: #41abc4;
    --el-button-border-color: #41abc4;
    --el-button-outline-color: var(--el-color-primary-light-5);
    --el-button-active-color: var(--el-color-primary-dark-2);
    --el-button-hover-text-color: var(--el-color-white);
    --el-button-hover-link-text-color: var(--el-color-primary-light-5);
    --el-button-hover-bg-color: #2699b2;
    --el-button-hover-border-color: #2699b2;
    --el-button-active-bg-color: var(--el-color-primary-dark-2);
    --el-button-active-border-color: var(--el-color-primary-dark-2);
    --el-button-disabled-text-color: var(--el-color-white);
    --el-button-disabled-bg-color: var(--el-color-primary-light-5);
    --el-button-disabled-border-color: var(--el-color-primary-light-5);
}

.profile-card-button .el-button {
    width: 100%;
    position: relative;
    justify-content: left;
    cursor: pointer;
    height: 38px;
    border-radius: 5px;
}
</style>